import { StyleSheet } from "@react-pdf/renderer";
import { blue, white } from "./PDFColors";

export const styles = StyleSheet.create({
  backgroundBlue: {
    height: "100%",
    width: "100%",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "10pt",
  },
  eventsContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
  },

  eventsBox: {
    width: "28%",
    height: "92%",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "1pt",
    justifyContent: "center",
    alignItems: "center",
    margin: "15px",
  },
  titleBox: {
    height: "10%",
    width: "100%",
    borderBottomStyle: "solid",
    borderBottomColor: blue,
    borderBottomWidth: "1pt",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: blue,
  },
  textTitle: { color: white },

  textBox: {
    width: "100%",
    height: "90%",
    textAlign: "left",
    padding: "4px",
  },
  text: { fontSize: "11px", margin: "2px" },
});
